import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20e87e03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar-uploader__media" }
const _hoisted_2 = { class: "avatar-uploader__preview" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "avatar-uploader__placeholder"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "avatar-uploader__meta"
}
const _hoisted_7 = { class: "avatar-uploader__meta-head" }
const _hoisted_8 = { class: "avatar-uploader__title-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "avatar-uploader__title" }, "Ảnh đại diện", -1))
const _hoisted_10 = {
  key: 0,
  class: "avatar-uploader__badge avatar-uploader__badge--pending"
}
const _hoisted_11 = {
  key: 1,
  class: "avatar-uploader__badge avatar-uploader__badge--ready"
}
const _hoisted_12 = { class: "avatar-uploader__hint" }
const _hoisted_13 = {
  key: 0,
  class: "avatar-uploader__pending"
}
const _hoisted_14 = { class: "avatar-uploader__pending-text" }
const _hoisted_15 = { class: "avatar-uploader__actions" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Chỉnh sửa lại", -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hủy", -1))
const _hoisted_21 = {
  key: 1,
  class: "avatar-uploader__idle-note"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarCropModal = _resolveComponent("AvatarCropModal")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["avatar-uploader", { 'is-pending': !!_ctx.pendingFile, 'is-busy': _ctx.uploading }])
  }, [
    _createVNode(_component_AvatarCropModal, {
      modelValue: _ctx.isCropOpen,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCropOpen) = $event)),
      "image-src": _ctx.editorSrc,
      "file-name": _ctx.sourceFileName,
      "mime-type": _ctx.sourceMimeType,
      "max-size-mb": _ctx.maxSizeMb,
      onConfirm: _ctx.onCropConfirm,
      onCancel: _ctx.onCropCancel
    }, null, 8, ["modelValue", "image-src", "file-name", "mime-type", "max-size-mb", "onConfirm", "onCancel"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.displaySrc)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.displaySrc,
              alt: _ctx.alt,
              class: "avatar-uploader__image"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faUser }, null, 8, ["icon"])
            ]))
      ]),
      (_ctx.editable)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: _normalizeClass(["avatar-uploader__pick", { 'is-disabled': _ctx.uploading }]),
            title: "Chọn ảnh đại diện"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.faCamera }, null, 8, ["icon"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.pendingFile ? 'Chọn ảnh khác' : 'Đổi ảnh'), 1),
            _createElementVNode("input", {
              ref: "fileInputRef",
              type: "file",
              accept: ".png,.jpg,.jpeg,.gif,.webp,image/png,image/jpeg,image/gif,image/webp",
              class: "avatar-uploader__input",
              disabled: _ctx.uploading,
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
            }, null, 40, _hoisted_5)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.editable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (_ctx.pendingFile)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Chưa tải lên "))
                : (_ctx.modelValue)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Đang dùng "))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_12, " jpg, jpeg, png, gif, webp · tối đa " + _toDisplayString(_ctx.maxSizeMb) + "MB. Chọn ảnh để cắt / chỉnh trước khi tải lên. ", 1)
          ]),
          (_ctx.pendingFile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.uploading
              ? 'Đang tải ảnh lên, vui lòng chờ…'
              : 'Ảnh đã chỉnh sẵn sàng. Tải lên để áp dụng, hoặc chỉnh sửa lại.'), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "avatar-uploader__btn avatar-uploader__btn--primary",
                    disabled: _ctx.uploading,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.uploading ? _ctx.faSpinner : _ctx.faCloudArrowUp,
                      spin: _ctx.uploading
                    }, null, 8, ["icon", "spin"]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.uploading ? 'Đang tải lên…' : 'Tải ảnh lên'), 1)
                  ], 8, _hoisted_16),
                  _createElementVNode("button", {
                    type: "button",
                    class: "avatar-uploader__btn",
                    disabled: _ctx.uploading,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reopenEditor && _ctx.reopenEditor(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: _ctx.faPen }, null, 8, ["icon"]),
                    _hoisted_18
                  ], 8, _hoisted_17),
                  _createElementVNode("button", {
                    type: "button",
                    class: "avatar-uploader__btn avatar-uploader__btn--muted",
                    disabled: _ctx.uploading,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelPending && _ctx.cancelPending(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: _ctx.faXmark }, null, 8, ["icon"]),
                    _hoisted_20
                  ], 8, _hoisted_19)
                ])
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_21, " Ảnh tải lên bằng API riêng, không phụ thuộc nút Lưu hồ sơ. "))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}